import { render, staticRenderFns } from "./ProductsCollectionThumb.vue?vue&type=template&id=597826de&lang=pug&"
import script from "./ProductsCollectionThumb.vue?vue&type=script&lang=js&"
export * from "./ProductsCollectionThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports